
/* styles */
require("!!../../../../../../azure/movemais.client/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/style-rewriter?id=data-v-6246e9f0&scoped=true!sass-loader?sourceMap!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=styles&index=0!./app-header.vue")

var Component = require("!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=script&index=0!./app-header.vue"),
  /* template */
  require("!!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-6246e9f0!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./app-header.vue"),
  /* scopeId */
  "data-v-6246e9f0",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/layout/app-header.vue
// module id = 1890
// module chunks = 1